import { Factory } from 'rosie';

const snippetId = 'example-snippet-id';

Factory.define('SnippetEditor').attr('name', 'SNIPPET_EDITOR');

Factory.define('SnippetEditorWithDefaults').extend('SnippetEditor').attr('snippetId', snippetId);
